import GoogleTagManager from "@redux-beacon/google-tag-manager";
import { createAction } from "@reduxjs/toolkit";
import { createMiddleware, EventsMap } from "redux-beacon";
import { RootState } from "../../store";
import { TBackendAnalytics } from "./types";
import { areAnalyticsEnabled } from "../../utils";

const actionTypes = {
  ANALYTICS_PUSH_TYPE: "gtm/PUSH_ANALYTICS",
  ANALYTICS_ONBOARDING_TYPE: "onboardingApi/executeMutation/fulfilled",
  ANALYTICS_RESUME_TYPE: "resumeApi/executeMutation/fulfilled",
};

type TClean = keyof TBackendAnalytics;

// Set empty properties or null properties to "undefined"
const cleanEvents = (event: TBackendAnalytics) => {
  return (Object.keys(event || {}) as TClean[]).reduce<Record<TClean, string>>(
    (acc, key: TClean) => {
      if (event[key] === "" || event[key] === null) {
        return { ...acc, [key]: undefined };
      }
      return { ...acc, [key]: event[key] };
    },
    {} as Record<keyof TBackendAnalytics, string>,
  );
};

const eventsMap: EventsMap = areAnalyticsEnabled
  ? {
      [actionTypes.ANALYTICS_ONBOARDING_TYPE]: action => {
        return cleanEvents(action.payload?.analytics);
      },
      [actionTypes.ANALYTICS_RESUME_TYPE]: action => {
        return cleanEvents(action.payload?.analytics);
      },
      [actionTypes.ANALYTICS_PUSH_TYPE]: (action, state: RootState) => {
        return cleanEvents({
          ...(state?.onboarding?.data?.analytics || {}),
          ...action.payload,
        });
      },
    }
  : {};

export const pushAnalytics = createAction<Partial<TBackendAnalytics>>(
  actionTypes.ANALYTICS_PUSH_TYPE,
);

const gtm = GoogleTagManager();
export const gtmMiddleware = createMiddleware(eventsMap, gtm);
